import { GAME_HEIGHT, GAME_WIDTH } from '@/config/gameConfig';

export interface LaneLayout {
  playerId: number;
  hitZoneX: number;
  trackY: number;
  trackWidth: number;
  trackHeight: number;
  trackX: number;
  fadeEndX: number;
  accumulatedStartX: number;
}

const DEFAULT_TRACK_HEIGHT = 110;
const LANE_MARGIN = 20;
const SENT_TRACK_MARGIN = 30;

export function calculateHorizontalLayouts(playerCount: number): LaneLayout[] {
  const laneWidth = GAME_WIDTH / playerCount;
  const trackHeight = DEFAULT_TRACK_HEIGHT;
  const trackY = GAME_HEIGHT / 2 + 40;

  return Array.from({ length: playerCount }, (_, i) => {
    const centerX = laneWidth * (i + 0.5);
    const trackWidth = laneWidth - LANE_MARGIN * 2;
    const trackX = centerX - trackWidth / 2;

    return {
      playerId: i,
      hitZoneX: centerX,
      trackY,
      trackWidth,
      trackHeight,
      trackX,
      fadeEndX: trackX + SENT_TRACK_MARGIN * 2,
      accumulatedStartX: trackX + SENT_TRACK_MARGIN,
    };
  });
}

const MULTI_TRACK_HEIGHT = 90;
const MULTI_AREA_TOP = 150;
const MULTI_AREA_BOTTOM = 640;

export function calculateVerticalLayouts(playerCount: number): LaneLayout[] {
  const totalHeight = MULTI_AREA_BOTTOM - MULTI_AREA_TOP;
  const laneHeight = totalHeight / playerCount;

  return Array.from({ length: playerCount }, (_, i) => {
    const laneTop = MULTI_AREA_TOP + i * laneHeight;
    // Reserve vertical breathing room above/below the lane for HUD text rows.
    // This keeps lane-local HUD readable at 2–4 players without overlapping.
    const headerGap = Math.min(40, Math.max(18, laneHeight * 0.25));
    const footerGap = Math.min(40, Math.max(18, laneHeight * 0.25));

    const maxTrackHeight = Math.max(56, laneHeight - headerGap - footerGap);
    const trackHeight = Math.min(MULTI_TRACK_HEIGHT, maxTrackHeight);

    const trackTop = laneTop + headerGap;
    const trackY = trackTop + trackHeight / 2;

    const trackX = 50;
    const trackWidth = GAME_WIDTH - 100;

    return {
      playerId: i,
      hitZoneX: GAME_WIDTH / 2,
      trackY,
      trackWidth,
      trackHeight,
      trackX,
      fadeEndX: trackX + SENT_TRACK_MARGIN * 2,
      accumulatedStartX: trackX + SENT_TRACK_MARGIN,
    };
  });
}
